import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";

export const NotificationTemplateAutoSubscribePolicyCodec = t.intersection([
  t.type({
    id: t.string,
    notificationTemplateId: t.string,
    enabled: t.boolean,
    defaultEmailEnabled: t.boolean,
    defaultPushEnabled: t.boolean,
    defaultSmsEnabled: t.boolean,
  }),
  t.partial({

  }),
]);

export type NotificationTemplateAutoSubscribePolicy = t.TypeOf<typeof NotificationTemplateAutoSubscribePolicyCodec>;

@Exclude()
export class NotificationTemplateAutoSubscribePolicyEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  notificationTemplateId!: string;

  @Expose()
  enabled!: boolean;

  @Expose()
  defaultEmailEnabled!: boolean;

  @Expose()
  defaultPushEnabled!: boolean;

  @Expose()
  defaultSmsEnabled!: boolean;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  @Expose()
  createdByName?: string;

  readonly entityType = "NOTIF_TEMP_AUTO_SUB_POL";

  get displayName(): Readonly<string> {
    return this.id;
  }

  constructor() {
  }

  static from(value: NotificationTemplateAutoSubscribePolicy): NotificationTemplateAutoSubscribePolicyEntity {
    return plainToInstance(NotificationTemplateAutoSubscribePolicyEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<NotificationTemplateAutoSubscribePolicy> {
    const object = instanceToPlain(this, {excludeExtraneousValues: true});
    return validateJSON(NotificationTemplateAutoSubscribePolicyCodec, object);
  }

  asTypeValue(): NotificationTemplateAutoSubscribePolicy {
    const object = instanceToPlain(this, {excludeExtraneousValues: true});
    return validateJSONNow(NotificationTemplateAutoSubscribePolicyCodec, object);
  }
}
